// @flow
export function capitalize(value: string): string {
  if (!value) return '';

  value = String(value).toLowerCase();
  return value.replace(/(^|\s)\S/g, letter => letter.toUpperCase());
}

export function capitalizeName(name: string): string {
  return capitalize(name).replace(/D(?=(o|a|e|as|os)\s)/g, 'd');
}

export function capitalizeFirstLetter(text: string): string {
  let splitedString = text.split(' ');
  splitedString.map((word, index) => {
    word = word.toLowerCase();
    splitedString[index] = word.charAt(0).toUpperCase() + word.slice(1);
  });
  return splitedString.join(' ');
}
